
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NbDialogService } from '@nebular/theme';
import * as _ from 'lodash';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-select-store-opsetting',
  templateUrl: './select-store-opsetting.component.html',
  styleUrls: ['./select-store-opsetting.component.scss']
})
export class SelectStoreOpsettingComponent implements OnInit {
  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;

  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() title: string; 
  mainDataList: Array<any>; //已選資料
  infoList: Array<any>;     //選項資料
  showList: Array<any>;     //顯示資料
  @Input() info : {//其他設定    
    IsLoding:boolean
    ORG_Company_ID: number,
    ORG_Store_ID: number,
  };  
  query : {  //查詢選項
    searchKey : string
  } 
  status: { //當前狀態
    isSelectAll : boolean //是否已全選
    showType:number // 顯示有選過的
  }
  list={
    showType : [
      {name:"全部",value:0},
      {name:"已選",value:1},
      {name:"未選",value:2}]
  }

  
  opsettingCategoryList = {
    typeList: [
      {
        type: '開單設定',
        isSelect: true,
        settings: ["OpenORD"]
      },
      {
          type: '點餐設定',
          isSelect: true,
          settings: ["IsEditAttachItem"]
      },
      {
          type: '內用設定',
          isSelect: true,
          settings: ["IsTableNeed", "IsShowMealTime", "IsCheckoutLeave", "ChangeTableCanClear", 
            "LimitUsablePdGroup", "IsShowORDQRBtn", "MealTime", "SpacingTime", "LastTime", 
            "IsServiceBell", "RuleNote"]
      },
      {
          type: '選單設定',
          isSelect: true,
          settings: ["IsShowCheckInBtn", "IsShowCashBoxBtn"]
      },
      {
          type: '接單設定',
          isSelect: true,
          settings: ["AutoAccept", "OnlineNotice"]
      },
      {
          type: '出單設定',
          isSelect: true,
          settings: ["IsPrintFinalPDNameWithKitchen", "IsLabelFinalName", "IsKitchenCash", 
            "IsLabelCash", "PrintLabelDelPD", "IsLabelSource", "IsPrintCountSum", 
            "PrintAttachPDCount", "PrintPDSortType", "PrintAttSortType", "PrintDeletePD", 
            "IsPrintSubstation", "OpenProwillPrintTime","IsPrintSplite","IsPrintErrorNotice","IsTableManageShowPrintError", "PrintModel", "PrintInBackground", 
            "IsPrintFinalPDNameWithCustomer","ServiceFeeName","PrintCheckConnectModel","PrintDrawImageModel"]
      },
      {
          type: '結帳設定',
          isSelect: true,
          settings: ["IsShowInvCloseBtn", "IsShowInvReprintBtn", "ShowServiceFee", 
            "IsServiceFeeCanDiscount", "IsOnlineFUCheckout", "IsMultiplepayments", 
            "IsORDCampainSpecifyShare", "IsORDCampainCouponShare", "IsValidTaiwanBusinessID", 
            "IsORDAdditionalDiscount", "IsOpenOrder", "IsYOMember","IsDefaultPayment","IsQrcodeRedeem","IsUseCRMTaxID","IsNoDefaultCRMTaxID", "AutoPrint","IsRePrintCustomer"]
      },
    ]
  };

  modalRef = null;  //談窗鉤子
  

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) { 
     this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    
  }


  ngOnInit(): void {
    this.query = { searchKey :""}
  }


  ngAfterViewInit(){    console.log('sa',this.info)
    this.onOpen(this.info, this.orgData)
  }


  onAddAuto(obj){
    obj.isSelect = !obj.isSelect
  }


  //打開選擇附加品項

  @ViewChild('Modal') Modal :TemplateRef<any>
  onOpen(info,data) {
    if(info){
      this.info = info
    }
    if(data){
      this.orgData = data
    }
      
    //初始化查詢資料
    this.query.searchKey = ""
    this.mainDataList = []
    this.status= { 
      isSelectAll : true,
      showType:0
    }
    
    //處理已選資料
    if(this.orgData && this.orgData.length > 0){      
      this.mainDataList = _.cloneDeep(this.orgData)
      // this.orgDataList.forEach(x => {
      //   let obj = _.assign({}, x)
      //   this.mainDataList.push(obj)
      // })
    }    
    
    //撈取可選資料 並合成已選資料
    this.onQuery() 

    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  //查詢
  onQuery( ) {
    
    this.getInfoList((data)=>{
      
      //初始化
      this.infoList = data
      this.showList = data
      this.showList.forEach(x => {

        let obj = _.find(this.mainDataList, y => this.judgeSame(y,x))
        if (obj) {
          x.isSelect = true
        } else {
          x.isSelect = false
        }
      })

      this.filterShowType()
      this.judgeSelectAll()

    });

  }

  onShowType(){
    this.filterShowType()
    this.judgeSelectAll()
  }

  //選擇
  onSelect(isAdd:boolean, item ) {
    if(isAdd){
      item.isSelect = true
      this.mainDataList.push(item);

    }else{
      item.isSelect = false
      let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
      this.mainDataList.splice(index, 1);
    }    

    this.judgeSelectAll()
  }

  //全選
  onSelectAll(){
    
    
    if(this.status.isSelectAll){
      this.showList.forEach(item=>{
        item.isSelect = false
        let index = this.mainDataList.findIndex(x=>this.judgeSame(x,item))
        this.mainDataList.splice(index, 1);
      })
    }
    else{      
      this.showList.forEach(item=>{
        item.isSelect = true
        this.mainDataList.push(item);
      })
    }
    
    this.status.isSelectAll = !this.status.isSelectAll
  }

  onSave() {
    let unselected = [];
    this.orgData.splice(0,this.orgData.length );
    let i = 1;
    this.mainDataList.forEach(x=>{      
      x.Sorting = i;
      i++
      this.orgData.push(x)
    })


    this.opsettingCategoryList.typeList.forEach(category => {
      if (!category.isSelect && category.settings) {
        unselected.push(...category.settings);
      }
    });

    this.emitList.emit({
      orgData: this.orgData, 
      unselected: unselected
    });

    this.modalRef.close()

  }

  //-----------------------------------------------------------------

  //過濾已選未選等
  filterShowType(){
    if(this.status.showType==0){
      this.showList = _.concat([],this.infoList)
    }
    else if(this.status.showType==1){
      this.showList = _.filter(this.infoList,x=>x.isSelect)
    }
    else{
      this.showList = _.filter(this.infoList,x=> !x.isSelect)
    }
  }


  //判斷是否全選
  judgeSelectAll(){
    if(!this.showList || this.showList.length==0){
      return true
    } 
  
    this.status.isSelectAll = this.showList.every(x=>{
      return this.mainDataList.some(y=>this.judgeSame(y,x))    
    })
    

  }

  //---------------------------------------客製化-----------------------------------------

  //比較
  judgeSame(y , x){
    return y.ORG_Store_ID == x.ORG_Store_ID 
  
    
  }

   
  //取得選擇附加品項清單
  getInfoList( callback) {
    //取得含有商品的附加品項
    this.info.IsLoding= true
    this.http.post<any>('api/ORGStore/StoreList', {
      USR_AccountInfo_ID: this.USR_AccountInfo_ID, //建立者,
      
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID:"0",
    }).subscribe({
      next: data => {

        if(callback)
          callback(data.LIST)

          // selectItem.value = element.ORG_Store_ID;
          // selectItem.content = element.StoreName;
          this.info.IsLoding= false


      },
      error: error => {
        //this.errorMessage = error.message;
        console.error('There was an error!', error);
        this.info.IsLoding= false

      }
    });

  }


}